/**
 * Shown on a department report that came from the intern programme:
 * "Intern report · by <intern> (<group>) · approved by <team member>".
 */
export default function InternApprovalNote({ post, compact = false }) {
  const f = post?.fromIntern;
  if (!f) return null;
  return (
    <div title="Published by an intern and approved by a team member"
      style={{ display: 'flex', flexWrap: 'wrap', gap: 4, alignItems: 'center', padding: compact ? '4px 8px' : '6px 10px',
        borderRadius: 6, border: '1px solid #10b98155', background: '#10b98112', color: '#059669',
        fontFamily: "'Share Tech Mono',monospace", fontSize: compact ? 9 : 10, letterSpacing: 0.5, lineHeight: 1.4 }}>
      <span aria-hidden>🎓</span>
      <span>INTERN REPORT · BY {String(f.internName || 'Intern').toUpperCase()}{f.groupName ? ` (${String(f.groupName).toUpperCase()})` : ''}</span>
      <span>· APPROVED BY {String(f.approvedBy || '—').toUpperCase()}</span>
    </div>
  );
}
